import {Component} from "react";
import {logout} from "../../redux_actions/login.action";
import {Modal} from "antd";
import {store} from "../../helper/store";

class ForceLogout extends Component {

    handleLogout = (displayMessage = null, resolution = null) => {
        this.props.onClose();
        localStorage.setItem("showLogoutModal", "false");
        store.dispatch(logout(displayMessage, resolution));
    };

    render() {
        return (
            <Modal
                title="Force Logout"
                visible={this.props.visible}
                onOk={this.handleLogout}
                okText="Logout"
                okButtonProps={{style: {background: '#fff', borderColor: 'rgb(112,11,128)', color: 'rgb(112,11,128)'}}}
                closable={false}
                cancelButtonProps={{style: {display: 'none'}}}
            >
                <p>Kindly <b>logout</b> of your current session and log back in to experience the changes seamlessly.
                </p>
                <p>This ensures that the system captures and applies the updated {this.props.message} accurately. </p>
            </Modal>
        );
    }
}

export default ForceLogout;